export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const SET_AUTH_ERROR = "SET_AUTH_ERROR";
export const STAR_PEN = "STAR_PEN";

export const START_LOADING_POST = "START_LOADING_POST";
export const SET_ERROR = "SET_ERROR";
export const SET_SAVED = "SET_SAVED";
export const STOP_LOADING_POST = "STOP_LOADING_POST";
export const SET_ALL_PENS = "SET_ALL_PENS";
export const SET_PEN = "SET_PEN";
export const SET_NAME = "SET_NAME";
export const LIKE_PEN = "LIKE_PEN";
export const DELETE_PEN = "DELETE_PEN";
